// Vendor
import $ from 'jquery';
import 'tooltipster';
import 'jquery-touchswipe';
// Custom
import autocomplete from '../../../vendor/webcaravel/gk-framework/resources/js/app/autocomplete.custom.js';
import magnificPopup from '../../../vendor/webcaravel/gk-framework/resources/js/app/magnific-popup.custom.js';
import notifyCustom from "../../../vendor/webcaravel/gk-framework/resources/js/app/notify.custom";
import GKF from '../../../vendor/webcaravel/gk-framework/resources/js/app/gk-framework';

// Import jQuery+plugins
window.$ = window.jQuery = $;
autocomplete($);
magnificPopup($);
notifyCustom($);

// Initialize GKF
GKF.init(
    [
        ["Meine Bonuspunkte", "/user/bonuspunkte", "recipes"],
        true,
        ["Meine Kochbücher", "/user/user-bookmark/brz", "book"],
        ["Meine Cocktailkarten", "/user/user-bookmark/bck", "glass2"],
        ["Meine Artikel", "/user/user-bookmark/bar", "file"],
        true,
        ["Einkaufslisten", "/user/einkaufsliste", "list"],
        true,
        ["Rezept eintragen", "/user/rezept/eintragen/rezept", "edit"],
        ["Cocktail eintragen", "/user/rezept/eintragen/cocktail", "edit"],
        true,
        ["User Einstellungen", "/user/profil/edit", "address-book"],
        ["Mein Userprofil", "/user/profil", "profile"],
        ["User suchen", "/user/suche", "users"],
        ["E-Mail Abos", "/user/mailsetting", "mail"],
        true,
        ["Abmelden", "/gk-framework/auth/logout", "exit"]
    ],
    function() {
        // GKDE23-103 Werbungs AI Rückgang
        APP.pageViewActions.push(function(){
            console.log("pageViewActions.Refresh");
            typeof googletag !== 'undefined' && typeof googletag.pubads == "function" && googletag.pubads().refresh();
        });

        // Make all headings without links in mixed colors
        $('#main h1, #main h2, #main h3').each(function() {
            var text = this.innerHTML;
            var firstSpaceIndex = text.indexOf(" ");

            // Check if there is a link or somethin else in it
            if($(this).children().length > 0) return;

            if (firstSpaceIndex > 0) {
                var substrBefore = text.substring(0,firstSpaceIndex);
                var substrAfter = text.substring(firstSpaceIndex, text.length)
                var newText = '<span class="firstWord">' + substrBefore + '</span>' + substrAfter;
                this.innerHTML = newText;
            } else {
                this.innerHTML = '<span class="firstWord">' + text + '</span>';
            }
        });
    }
)
